import React from "react";

export const IconDuration = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.36636 1.15306C6.36636 0.792386 6.65875 0.5 7.01942 0.5H9.00046C9.36113 0.5 9.65352 0.792386 9.65352 1.15306C9.65352 1.51374 9.36113 1.80612 9.00046 1.80612H8.99609V2.19889C12.5236 2.67666 15.2417 5.68118 15.2417 9.31633C15.2417 13.2838 12.0039 16.5 8.00994 16.5C4.01596 16.5 0.778198 13.2838 0.778198 9.31633C0.778198 5.68118 3.49633 2.67666 7.0238 2.19889V1.80612H7.01942C6.65875 1.80612 6.36636 1.51374 6.36636 1.15306ZM7.99282 13.8333C10.4947 13.8333 12.5229 11.8186 12.5229 9.33333C12.5229 6.84805 10.4947 4.83333 7.99282 4.83333C5.49091 4.83333 3.46271 6.84805 3.46271 9.33333C3.46271 11.8186 5.49091 13.8333 7.99282 13.8333Z"
        fill="#232F3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.92269 5.8335V9.47668L10.3201 11.8581C9.69304 12.442 8.84987 12.7995 7.92263 12.7995C5.98615 12.7995 4.41632 11.2401 4.41632 9.3165C4.41632 7.39289 5.98615 5.8335 7.92263 5.8335C7.92265 5.8335 7.92267 5.8335 7.92269 5.8335Z"
        fill="#232F3E"
      />
    </svg>
  );
};
